module.exports = __webpack_public_path__ + "c7781181aa03e751f48e1bf08f28d271.MP3";